import { useMutation } from "react-query";
import { message } from "antd";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";
import { postDataWithDotNet } from "../../../../../newApis/dotNetApiMethods";
import { appInsights } from "../../../../../config/appInsights";
import { errorHandler } from "../../../../../helpers/errorHandler";

export type TAggregatorUserRolePayload = {
  userId: string;
  aggregatorId: number;
  roleNames: string[];
};

const addAggregatorUserRole = async (
  payload: TAggregatorUserRolePayload,
): Promise<void> => {
  await postDataWithDotNet(ajaxEndpoints.ADD_AGGREGATOR_USER_ROLE, payload);
};

const removeAggregatorUserRole = async (
  payload: TAggregatorUserRolePayload,
): Promise<void> => {
  await postDataWithDotNet(ajaxEndpoints.REMOVE_AGGREGATOR_USER_ROLE, payload);
};

const onError = (fileName: string) => (error: any) => {
  appInsights.trackException({
    exception: error,
    properties: { fileName },
  });
  message.error(errorHandler(error));
};

export function useAddAggregatorUserRole() {
  const [mutate, result] = useMutation(addAggregatorUserRole, {
    onError: onError("useAssignAggregatorUserRole.ts"),
  });

  return { mutate, result };
}

export function useRemoveAggregatorUserRole() {
  const [mutate, result] = useMutation(removeAggregatorUserRole, {
    onError: onError("useAssignAggregatorUserRole.ts"),
  });

  return { mutate, result };
}
